export default { customers: [] };
